export interface pagesInterface {
  id: string;
  name: string;
  path: string;
  modules: string[];
  layout: string;
  type: string;
  seo: {
    title: string;
    desc: string;
  };
  allow_edit?: boolean;
}

export function moduleExistsInLayouts(layouts: any, instance: string) {
  // i add || {} to Object.values(layouts || {}) because without that deleting module goes to error when layouts is undefined or null
  return Object.values(layouts || {}).some((layout: unknown) => {
    const typedLayout = layout as {
      topModules?: string[];
      bottomModules?: string[];
    };
    const { topModules = [], bottomModules = [] } = typedLayout;
    return [...topModules, ...bottomModules].includes(instance);
  });
}

export function moduleExistsInPages(pages: pagesInterface[], instance: string) {
  return (
    pages.find((page: any) => page?.modules?.includes(instance)) !== undefined
  );
}

export function deleteModuleLogic(
  state: any,
  instance: string,
  moduleName?: string
) {
  if (instance === moduleName || !instance?.includes('_')) {
    return;
  }
  const currModuleConfigs = { ...state.config.modulesConfigs };
  delete currModuleConfigs[instance]; // Remove the key
  state.config.modulesConfigs = currModuleConfigs;
  delete currModuleConfigs[instance]; // Remove the key
}
